import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DROPZONE_CONFIG, DropzoneModule } from 'ngx-dropzone-wrapper';
import { DropFileComponent } from './components/drop-file/drop-file.component';
import { DEFAULT_DROPZONE_CONFIG } from './models/drop-file-config.models';

@NgModule({
  imports: [CommonModule, DropzoneModule],
  declarations: [DropFileComponent],
  exports: [DropFileComponent],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG,
    },
  ],
})
export class SharedFeatureDropFileModule {}
